<template>
    <div id="settings-wrapper">
        <!-- >>> The Card/Button ------------------------------------------- -->
        <v-badge
            message="1"
            style="position: fixed; bottom:115px; right: 63px;">
            <v-icon icon="$vuetify" size="x-large"></v-icon>
            <v-card id="settings" class="py-2 px-4" color="rgba(0, 0, 0, .3)" dark flat link min-width="100" style="position: fixed; bottom: 78px; right: -35px; border-radius: 8px;">
                <v-icon large>
                    mdi-alert
                </v-icon>
            </v-card>
            <div class="flightsTable_selectedFlightsCounter">
                {{ get_ResourceTimeRangesWarningsList.length }}
            </div>
        </v-badge>

        <!-- <<< The Card/Button ------------------------------------------- -->

        <!-- >>> The Settings Menu ----------------------------------------- -->
        <v-menu v-model="menu" :close-on-content-click="false" activator="#settings" bottom content-class="v-settings" left nudge-left="8" offset-x origin="top right" transition="scale-transition">
            <v-card class="mb-0" width="850">
                <v-card-title class="grey headline" style="color: white; font-size: 15px; font-weight: 500;">
                    <p class="pl-7 mb-5 mt-5">
                        Warnings - 'List of Warnings'
                    </p>
                </v-card-title>

                <v-card-text class="pa-5">
                    <v-data-table
                        :headers="headers"
                        :items="get_ResourceTimeRangesWarningsList"
                        :single-expand="singleExpand"
                        :expanded.sync="expanded"
                        :fixed-header="false"
                        show-expand
                        height="500"
                        item-key="idResource"
                        hide-default-footer
                        disable-pagination
                    >

                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length">
                                <v-data-table
                                    :headers="headers2"
                                    :items="item.restrictions"
                                    hide-default-footer
                                >
                                    <template v-slot:item.fromDate="{ item }">
                                        <span> From: {{ item.fromDate |  formattedDate }}</span>
                                    </template>

                                    <template v-slot:item.toDate="{ item }">
                                        <span> To: {{ item.toDate |  formattedDate }}</span>
                                    </template>

                                    <template v-slot:item.error="{ item }">
                                        <span> Error: {{ String(item.error) }}</span>
                                    </template>
                                </v-data-table>
                            </td>

                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-menu>
        <!-- <<< The Settings Menu ----------------------------------------- -->
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { eventBus } from '../../../../../main.js';
    import moment from 'moment';


    export default {
        name: 'CrewplanningsWarningsList',

        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_ResourceTimeRangesWarningsList',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Filters */
        filters: {

            /*******************************************************************
            * formattedDate()
            *
            * Desc:
            *
            * @param {string} date (Date to reformat)
            * @return {string}
            */
            formattedDate: function(date) {

                return moment(date, moment.ISO_8601).format('DD.MM.YYYY'); // de:

            }, // eo function formattedDate()

        }, // eo filters{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // ----------------------------------
            menu: false,
            // ----------------------------------
            singleExpand: true,
            expanded: [],
            headers: [
                {
                    text: 'Resource with Warnings:',
                    align: 'start',
                    sortable: false,
                    value: 'resource',
                },
                { text: '', value: 'data-table-expand' },

            ],
            headers2: [
                {
                    text: 'From:',
                    align: 'start',
                    sortable: false,
                    value: 'fromDate',
                },
                {
                    text: 'To:',
                    align: 'start',
                    sortable: false,
                    value: 'toDate',
                },
                {
                    text: 'Type:',
                    align: 'start',
                    sortable: false,
                    value: 'type',
                },
                {
                    text: 'Error:',
                    align: 'start',
                    sortable: false,
                    value: 'error',
                },
            ],
        }), // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;



		}, // eo function created()
		/* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;



		}, // eo function destroyed()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([

            ]),


            /*******************************************************************
			* onChange_CalendarModeSwitch()
			*
			* Desc: Update the 'Calendar' Mode.
            * Note:
            *
			*/
            onChange_CalendarModeSwitch: function(value) {


            }, // eo function onChange_CalendarModeSwitch()





            /******************************************************************* 'Listeners - Emit''
            * Listeners:
            *******************************************************************/


        } // eo methods()
        /* <<< ****************************************************************/

    };
</script>


<style>
    .v-input--selection-controls.v-input .v-label {
        font-weight: 500 !important;
    }

    .theme--light.v-data-table.v-data-table--fixed-header thead th {
        background: none !important;
    }
</style>

<style scoped>
    .flightsTable_selectedFlightsCounter {
        position:absolute;
        top:-10px;
        right:-20px;
        width:30px;
        height:30px;
        background-color:#ab3b7a;
        border-radius:50%;
        display:flex;
        align-items:center;
        justify-content:center;
        font-weight: 500;
        color: #fff;
}
</style>